import type * as pageLoadKeys from './metric-keys/pageLoadKey.ts';
import type * as pageSegmentLoadKeys from './metric-keys/pageSegmentLoadKey.ts';
import { VIEW_PAGE_LOAD_KEY } from './metric-keys/pageLoadKey.ts';
import {
	APP_NAVIGATION_SEGMENT_KEY,
	BYLINE_SEGMENT_KEY,
	CONTENT_RENDERER_SEGMENT_KEY,
	CONTENT_TITLE_SEGMENT_KEY,
	CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY,
	CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY,
	END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
	FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY,
	FAVOURITE_BUTTON_SEGMENT_KEY,
	OBJECT_HEADER_SEGMENT_KEY,
	OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
	PAGE_TREE_SEGMENT_KEY,
	READ_TIME_SEGMENT_KEY,
	RESTRICTIONS_BUTTON_SEGMENT_KEY,
	SHARE_BUTTON_SEGMENT_KEY,
	SPACE_NAVIGATION_SEGMENT_KEY,
	VIEW_PAGE_CONTAINER_SEGMENT_KEY,
	VIEW_PAGE_LABELS_METRIC_KEY,
	WATCH_BUTTON_SEGMENT_KEY,
} from './metric-keys/pageSegmentLoadKey.ts';

type PageLoadExperienceKey = (typeof pageLoadKeys)[keyof typeof pageLoadKeys];
type PageSegmentExperienceKey =
	| (typeof pageSegmentLoadKeys)[keyof typeof pageSegmentLoadKeys]
	| PageLoadExperienceKey;

/**
 * Central migration scopes: the page load and the individual segments using UFO marks/data.
 * Both the owning UFO name and the segment key must match; shared segments under other
 * owners and unlisted segments under a listed owner retain BM3.
 *
 * The listed View Page segments permanently use the UFO marks/data path. Membership
 * does not certify complete BM3 offboarding: native segment events, page-load attributes and
 * callbacks must also pass with BM3 initialization disabled before removing legacy parents.
 * This is selection, not a copy of BM3's include/until completion graph.
 */
export const BM3_MIGRATION_SCOPES: ReadonlyArray<{
	pageLoadKey: PageLoadExperienceKey;
	// Raw interaction.ufoName values, before UFO replaces underscores in analytics names.
	ufoNames: readonly [string, ...string[]];
	segmentKeys: readonly PageSegmentExperienceKey[];
}> = [
	{
		pageLoadKey: VIEW_PAGE_LOAD_KEY,
		ufoNames: ['view_page'],
		segmentKeys: [
			// View Page's initial/transition segments, plus its header and content UI.
			APP_NAVIGATION_SEGMENT_KEY,
			BYLINE_SEGMENT_KEY,
			CONTENT_RENDERER_SEGMENT_KEY,
			CONTENT_TITLE_SEGMENT_KEY,
			CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY,
			CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY,
			END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
			FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY,
			FAVOURITE_BUTTON_SEGMENT_KEY,
			OBJECT_HEADER_SEGMENT_KEY,
			OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
			PAGE_TREE_SEGMENT_KEY,
			READ_TIME_SEGMENT_KEY,
			RESTRICTIONS_BUTTON_SEGMENT_KEY,
			SHARE_BUTTON_SEGMENT_KEY,
			SPACE_NAVIGATION_SEGMENT_KEY,
			VIEW_PAGE_CONTAINER_SEGMENT_KEY,
			VIEW_PAGE_LABELS_METRIC_KEY,
			WATCH_BUTTON_SEGMENT_KEY,
		],
	},
];
